import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { RiskOwnerFilters } from '../../../commons/models/risk-owner.model';

@Component({
  selector: 'app-risk-owner-filters',
  templateUrl: './risk-owner-filters.component.html',
  styleUrls: ['./risk-owner-filters.component.scss']
})
export class RiskOwnerFiltersComponent {


  @Output()
  onFilter: EventEmitter<RiskOwnerFilters> = new EventEmitter();

  private _defaultFilters: RiskOwnerFilters;
  filtersForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this._createForm();
  }

  private _createForm() {
    let group = {
      search: "",
    }

    this.filtersForm = this.fb.group(group);
  }

  applyFilters() {
    this.onFilter.emit(this._getRiskOwnerFilters());
  }

  private _getRiskOwnerFilters(): RiskOwnerFilters {
    let filters: RiskOwnerFilters = {}
    if (this.filtersForm) {
      const values = this.filtersForm.value;
      filters.search = values.search;
    }
    return filters;
  }

  resetFilters() {
    this.filtersForm.reset();
    this.filtersForm.patchValue({
      search: "",
    });
    this._setDefaultValues();
    this.applyFilters();
  }

  get defaultFilters(): RiskOwnerFilters {
    return this._defaultFilters;
  }

  @Input()
  set defaultFilters(defaultFilters: RiskOwnerFilters) {
    this._defaultFilters = defaultFilters;
    this._setDefaultValues();
  }

  private _setDefaultValues() {
    if (this.defaultFilters) {
      if (this.filtersForm) {
        this.filtersForm.patchValue({
          search: this.defaultFilters.search,
        })
      }
    }
  }
}
